import FastClick from 'fastclick';
import sanitizeHTML from 'sanitize-html';
import { DatetimePicker } from 'vant';
import 'vant/lib/datetime-picker/style';
import Vue from 'vue';
import App from './App.vue';
import MessageBox from './components/Alert/index';
import router from './router';
import store from './store';

// Raven.config(sentry.dsn)
// 	.addPlugin(RavenVue, Vue)
// 	.install();
// eslint-disable-next-line no-unused-vars
// const vConsole = require('@/lib/vconsole.min.js');
const wx = require('weixin-js-sdk');
window.wx = wx;

Vue.use(MessageBox);
Vue.use(DatetimePicker);

Vue.config.productionTip = false;
Vue.config.errorHandler = (err, vm, info) => {
	// Raven.captureException(err);
	console.log('Error: ', err);
};
window.onerror = function (e) {
	// Raven.captureException(e);
	console.log('Error: ', e);
};
Vue.prototype.$wx = wx;
Vue.prototype.$sanitize = function (html) {
	return sanitizeHTML(html, { allowedTags: sanitizeHTML.defaults.allowedTags.concat([ 'img' ]) });
};

FastClick.attach(document.body);

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');
